/** Map a source-video time (the editor playhead) to the output clip
 *  timeline defined by the kept intervals. Times in cut regions snap to
 *  the start of the next kept interval. */
export function videoTimeToClipTime(
  videoTime: number,
  intervals: Array<{ startTime: number; endTime: number }>,
): number {
  let offset = 0;
  for (const iv of intervals) {
    if (videoTime >= iv.startTime && videoTime < iv.endTime) {
      return offset + videoTime - iv.startTime;
    }
    offset += iv.endTime - iv.startTime;
  }
  offset = 0;
  for (const iv of intervals) {
    offset += iv.endTime - iv.startTime;
    if (videoTime === iv.endTime) return offset;
  }
  let acc = 0;
  for (const iv of intervals) {
    if (videoTime >= iv.endTime) {
      acc += iv.endTime - iv.startTime;
      continue;
    }
    if (videoTime > iv.startTime) return acc + (videoTime - iv.startTime);
    return acc;
  }
  return acc;
}
